<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        
        <!-- Detalle de la consulta -->
       <b-card>
            <b-tabs content-class="mt-3" lazy v-model="tabIndex" >
            
              <b-tab  title="Sin Liquidador" >
                 <sinliquidador>
                 </sinliquidador>
              </b-tab>

              <b-tab  title="En Proceso" >
                 <enproceso>
                 </enproceso>
              </b-tab>

              <b-tab  title="Sin Cobrador" >
                 <sincobrador>
                 </sincobrador>  
              </b-tab>
              
              <b-tab  title="Otros" >
                <otros>
                </otros>
              </b-tab>
              
            </b-tabs>
         
      </b-card>

      </b-col>
    </b-row>
    
   
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


import XLSX from "xlsx";

 import sinliquidador from './sinliquidador.vue';
 import enproceso from './enproceso.vue';
 import sincobrador from './sincobrador.vue';
 import otros from './otros.vue';

export default {
  name: "Seguimiento",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  
  props: {
    tag: Number,

  },

  components: {
    cSwitch
  },
  data: function() {
    return {
      tieneAcceso: true,
      tabIndex: 0,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      
    };
  },
  components:{
    Datepicker,
     Multiselect,
     sinliquidador,
     enproceso,
     sincobrador,
     otros
  },
  methods:{
    pre_insertar() {

      // console.log('tag', this.$route.query.tag);
      this.tabIndex = this.$route.query.tag;
    },
    
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();  
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
